<template>
  <appbar-view />
  <v-app>
    <v-main>
      <div class="min-h-screen bg-blue-900 text-white pb-20">
        <!-- Header -->
        <div class="flex justify-between items-center p-4 border-b border-blue-800">
        </div>
        <!-- Saludo -->
        <div class="px-4 py-6 space-y-2">
          <h2 class="text-2xl font-bold"></h2>
          <h2 class="text-1xl font-bold">Hola , {{ user?.denominacion_comercial || 'Usuario' }}</h2>

          <div class="flex items-center gap-2 mt-1 flex-wrap">
            <span class="bg-orange px-2 py-1 rounded text-black text-xs font-semibold">
              {{ user?.udn || 'Sucursal' }}
            </span>
            <span class="text-sm">No de Cliente: {{ user?.cliente || 'N/A' }}</span>
            <span class="text-sm ml-2 break-words">{{ user?.email || '' }}</span>
            <button @click="copyId" class="ml-auto">
              <v-icon size="20">mdi-content-copy</v-icon>
            </button>
          </div>

          <div class="text-sm text-gray-300">
            <strong>Razón social:</strong> {{ user?.razon_social || user?.razon || '-' }}
          </div>
          <div class="text-sm text-gray-300">
            <strong>RFC:</strong> {{ user?.rfc || user?.razon || '-' }}
          </div>

          <!-- 
          
        
                <div v-if="direcciones.length > 0">
            <div v-for="(dir, index) in direcciones" :key="index" class="mb-2">
              <p><strong>Calle:</strong> {{ dir.CTEDIR_CALLE }}</p>
              <p><strong>Colonia:</strong> {{ dir.CTEDIR_COLONIA }}</p>
              <p><strong>C.P.:</strong> {{ dir.CTEDIR_CP }}</p>
              <p><strong>Día de entrega:</strong> {{ dir.dia }}</p>
            </div>
          </div>
              <div v-if="direcciones.length > 0">
            <div v-for="(dir, index) in direcciones" :key="index" class="mb-2">
              <p><strong>Calle:</strong> {{ dir.CTEDIR_CALLE }}</p>
              <p><strong>Colonia:</strong> {{ dir.CTEDIR_COLONIA }}</p>
              <p><strong>C.P.:</strong> {{ dir.CTEDIR_CP }}</p>
              <p><strong>Día de entrega:</strong> {{ dir.dia }}</p>
            </div>
          </div>

          <div v-else>
            No tienes direcciones registradas.
          </div>


        -->

        </div>




        <!-- Tabs -->
        <div class="flex justify-around bg-blue-800 py-3 mb-4 rounded-md mx-4">
          <div v-for="tab in tabs" :key="tab.name" @click="selectTab(tab.name)"
            class="flex-1 text-center cursor-pointer py-2 rounded-md"
            :class="selectedTab === tab.name ? 'bg-yellow-500 text-black font-semibold' : 'text-white'">
            <v-icon size="20" class="mb-1">{{ tab.icon }}</v-icon>
            <div class="text-sm">{{ tab.label }}</div>
          </div>
        </div>

        <!-- TAB: PUNTOS -->
        <div v-if="selectedTab === 'puntos'" class="mx-4 p-4 bg-blue-800 rounded-lg shadow space-y-2">
          <!-- contenido existente de puntos -->
          <div class="flex justify-between items-center">
            <span class="text-sm">Saldo de puntos</span>
            <span class="text-sm underline cursor-pointer" @click="obtenerNuevaData">
              {{ updatingPoints ? 'Actualizando...' : 'Actualizar puntos' }}
            </span>

          </div>
          <div class="mt-2 p-4 bg-blue-700 rounded-lg flex items-center justify-between">
            <div>
              <p class="text-sm">¡Lo estás haciendo muy bien!</p>
              <p class="text-2xl font-bold">
                {{ Math.floor(user.mvCoins || 0).toLocaleString() }} Puntos
              </p>
              <p class="text-xs text-gray-300">Tus puntos nunca vencen</p>
            </div>
            <img src="https://mvexpress.mx/images/mvsimple.png" class="w-12 h-12" alt="mvcoins" />
          </div>

        </div>

        <!-- TAB: HISTORIAL -->

        <div v-if="selectedTab === 'historial'" class="mx-4 mt-4 bg-blue-800 rounded-lg p-4 text-white">
          <h3 class="text-lg font-bold mb-3">Historial de pedidos</h3>

          <div v-if="loadingPedidos" class="text-center py-6 text-gray-300">
            Cargando pedidos...
          </div>

          <div v-else-if="pedidos.length === 0" class="text-center py-6 text-gray-300">
            No tienes pedidos registrados.
          </div>
          <!-- LISTA DE PEDIDOS -->
          <div v-else>
            <div v-for="pedido in pedidosOrdenados" :key="pedido.referencia_frog" @click="showProducto(pedido)"
              class="bg-blue-700 hover:bg-blue-600 transition rounded-lg p-3 mb-3 cursor-pointer">
              <!-- Primera fila -->
              <div class="flex justify-between items-center">
                <span class="font-bold text-orange-300">
                  Pedido #{{ pedido.referencia_frog }}
                </span>

                <span class="text-sm text-gray-200">
                  {{ new Date(pedido.fecha_pedido).toLocaleDateString('es-MX') }}
                </span>
              </div>

              <!-- Segunda fila -->
              <div class="flex justify-between mt-2">
                <span class="text-sm">
                  Estado: <span class="font-semibold">{{ pedido.estado }}</span>
                </span>

                <span class="text-sm font-bold">
                  ${{ pedido.total }}
                </span>
              </div>

              <!-- Tercera fila -->
              <div class="text-sm mt-1 text-gray-300">
                Sucursal: {{ pedido.CTECLI_DENCOMERCIA }}
              </div>
            </div>
          </div>



        </div>

        <!-- MODAL DETALLE DEL PEDIDO -->
        <v-dialog v-model="dialogDetalle" fullscreen transition="dialog-bottom-transition">
          <v-card class="bg-blue-800 text-white h-full relative">

            <!-- 🔥 BOTÓN CERRAR ARRIBA DERECHA (solo icono) -->
            <v-btn icon variant="text" class="absolute top-3 right-3 z-50" @click="dialogDetalle = false">
              <v-icon size="32" color="red">mdi-close</v-icon>
            </v-btn>

            <!-- 🔵 TÍTULO -->
            <v-card-title class="text-lg font-bold text-center py-4 mt-2">
              Detalle del pedido
            </v-card-title>

            <!-- 🔵 Sucursal -->
            <div class="px-4 text-center font-bold text-white">
              <strong>Sucursal:</strong> {{ detallePedido.CTECLI_DENCOMERCIA }}
            </div>

            <v-card-text class="overflow-y-auto mt-4 pb-20">

              <div v-if="!detallePedido || !detallePedido.detalles?.length"
                class="text-center py-4 text-gray-300 text-lg">
                No hay detalles disponibles para este pedido.
              </div>

              <div v-else>

                <!-- TABLA -->
                <table class="w-full text-sm text-left border-collapse bg-white rounded-lg">
                  <thead>
                    <tr class="border-b bg-blue-200 text-black">
                      <th class="px-2 py-2 text-center">Img</th>
                      <th class="px-2 py-2">Producto</th>
                      <th class="px-2 py-2 text-center">Cant</th>
                      <th class="px-2 py-2 text-right">Subtotal</th>
                    </tr>
                  </thead>

                  <tbody class="text-black">
                    <tr v-for="(detalle, index) in detallePedido.detalles" :key="index" class="border-b">
                      <td class="px-2 py-2 text-center">
                        <v-img :src="detalle.foto" max-width="45" max-height="45" class="rounded mx-auto" contain />
                      </td>
                      <td class="px-2 py-2">{{ detalle.nombre }}</td>
                      <td class="px-2 py-2 text-center">{{ detalle.cantidad }}</td>
                      <td class="px-2 py-2 text-right">${{ detalle.subtotal }}</td>
                    </tr>

                    <tr class="font-bold bg-gray-200">
                      <td colspan="2" class="px-2 py-2 text-right">Total Cantidad:</td>
                      <td class="px-2 py-2 text-center">
                        {{detallePedido.detalles.reduce((a, b) => a + Number(b.cantidad), 0)}}
                      </td>
                      <td class="px-2 py-2 text-right">
                        ${{detallePedido.detalles.reduce((a, b) => a + Number(b.subtotal), 0)}}
                      </td>
                    </tr>

                    <tr class="bg-orange-500 font-bold text-white">
                      <td colspan="3" class="px-2 py-2 text-right">MV Coins Ganados:</td>
                      <td class="px-2 py-2 text-right">
                        ${{ Number(detallePedido.detalles[0]?.mv_coins_ganados || 0).toLocaleString("es-MX",
                          {minimumFractionDigits:2}) }}
                      </td>
                    </tr>
                  </tbody>
                </table>

                <!-- Totales -->
                <div class="mt-6 text-right border-t border-blue-600 pt-4 text-lg">
                  <div><strong>Total:</strong> ${{ Number(detallePedido.total).toLocaleString("es-MX",
                    {minimumFractionDigits:2}) }}</div>
                  <div><strong>Estado:</strong> {{ detallePedido.estado }}</div>
                </div>

              </div>
            </v-card-text>
          </v-card>
        </v-dialog>


        <!-- TAB: BENEFICIOS -->
        <div v-if="selectedTab === 'beneficios'" class="mx-4 mt-4 bg-blue-800 rounded-lg p-4">
          <h3 class="text-lg font-bold mb-2">Beneficios</h3>
          <p class="text-sm text-gray-300">Pronto podrás ver tus beneficios exclusivos aquí.</p>
        </div>

        <!-- TAB: POLÍTICA DE PRIVACIDAD -->
        <div v-if="selectedTab === 'politica'" class="mx-4 mt-4 bg-blue-800 rounded-lg p-4 text-gray-200">
          <v-card class="rounded-lg p-6 bg-white text-gray-800 shadow-sm max-h-[600px] overflow-y-auto">
            <div class="text-center mb-6">
              <h1 class="text-3xl font-bold">Aviso de Privacidad</h1>
              <p class="text-gray-500 mt-2 text-sm">Distribuidora de Refrescos Grupo MV</p>
            </div>

            <!-- Datos del cliente -->
            <div v-if="cliente" class="mb-6 p-4 bg-gray-50 rounded-lg border border-gray-200 text-sm">
              <h2 class="font-semibold mb-2 flex items-center gap-2">
                <v-icon color="blue">mdi-account-circle</v-icon>
                Tus datos
              </h2>
              <v-container class="py-10 max-w-2xl mx-auto">

                <!-- Encabezado con estilo premium -->
                <div class="text-center mb-6">
                  <v-icon color="indigo-darken-3" size="80">mdi-shield-lock</v-icon>
                  <h1 class="text-3xl font-bold mt-4 text-gray-800">Aviso de Privacidad</h1>
                  <p class="text-gray-500 text-sm">Distribuidora Grupo MV</p>
                </div>

                <!-- Tarjeta principal -->
                <v-card class="rounded-2xl shadow-xl border bg-white overflow-hidden">

                  <!-- Sección Datos del Cliente -->
                  <div class="bg-indigo-600 text-white px-6 py-4">
                    <h2 class="text-xl font-semibold flex items-center gap-2">
                      <v-icon color="white">mdi-account-circle</v-icon>
                      Tus datos registrados
                    </h2>
                  </div>

                  <div class="px-6 py-6 bg-white text-gray-700">
                    <div class="grid grid-cols-1 md:grid-cols-2 gap-4 text-sm">
                      <div><strong>No de Cliente:</strong><br> {{ cliente?.cliente }}</div>
                      <div><strong>Correo:</strong><br> {{ cliente?.email }}</div>
                      <div><strong>Teléfono:</strong><br> {{ cliente?.telefono || "Sin dato" }}</div>
                      <div><strong>Razón Social:</strong><br> {{ cliente?.razon }}</div>
                      <div><strong>Comercial:</strong><br> {{ cliente?.denominacion_comercial }}</div>
                      <div><strong>RFC:</strong><br> {{ cliente?.rfc }}</div>
                      <div><strong>Ruta reparto:</strong><br> {{ cliente?.ruta_reparto }}</div>
                      <div>
                        <strong>Política aceptada:</strong><br>
                        <v-chip :color="cliente?.politica_privacidad_aceptada ? 'green' : 'red'" class="mt-1"
                          size="small">
                          {{ cliente?.politica_privacidad_aceptada ? 'Aceptada' : 'Pendiente' }}
                        </v-chip>
                      </div>
                      <div>
                        <strong>Fecha de aceptación:</strong><br>
                        {{ cliente?.fecha_politica_privacidad
                          ? new Date(cliente.fecha_politica_privacidad).toLocaleDateString('es-MX')
                          : "Pendiente"
                        }}
                      </div>
                    </div>
                  </div>

                  <!-- Contenido de la política con estilo profesional -->
                  <div class="px-6 py-6 bg-gray-50 border-t">
                    <h2 class="text-xl font-semibold text-gray-800 mb-3">
                      {{ privacyPolicy?.title }}
                    </h2>

                    <p class="text-sm text-gray-500 mb-1">
                      <strong>Versión:</strong> {{ privacyPolicy?.version }}
                    </p>

                    <div class="leading-relaxed text-gray-700 text-[15px] prose prose-slate max-w-none"
                      style="line-height: 1.6; height: 320px; overflow-y: auto; text-align: justify; text-justify: inter-word;"
                      v-html="privacyPolicy?.content" ref="scrollBox" @scroll="onScroll"></div>

                    <p class="text-xs text-gray-500 mt-4">
                      <strong>Última actualización:</strong>
                      {{ new Date(privacyPolicy?.publishedAt).toLocaleDateString() }}
                    </p>
                  </div>
                </v-card>
              </v-container>
            </div>
          </v-card>
        </div>

        <div v-if="selectedTab === 'direcciones'" class="mx-4 mt-4 bg-blue-800 rounded-lg p-4 space-y-4">
          <h3 class="text-lg font-bold text-white">Mis direcciones</h3>

          <!-- Si hay direcciones -->
          <div v-if="direccionesFiltradas.length > 0" class="space-y-3">

            <div v-for="(direccion, index) in direccionesFiltradas" :key="index"
              class="p-4 rounded-lg shadow transition-all border" :class="[
                direccion.CTEDIR_TIPOFIS == 1
                  ? 'bg-gray-200 text-gray-600 border-gray-300 opacity-70 cursor-not-allowed'
                  : direccionSeleccionada && direccion.CTEDIR_CODIGO_K === direccionSeleccionada.CTEDIR_CODIGO_K
                    ? 'bg-green-100 text-gray-800 border-green-400 cursor-pointer'
                    : 'bg-blue-700 text-white border-blue-500 cursor-pointer'
              ]">
              <!-- TÍTULO -->
              <div class="font-semibold text-base mb-2">
                {{ direccion.CTEDIR_TIPOFIS == 1 ? "Dirección de facturación" : "Dirección de entrega" }}
              </div>

              <!-- INFO EN LISTA -->
              <ul class="text-sm space-y-1">
                <li><strong>Preventa:</strong> {{ direccion.VTARUT_CODIGO_K_PRE || '-' }}</li>
                <li>
                  <strong>Calle:</strong> {{ direccion.CTEDIR_CALLE }}
                  Ext. {{ direccion.CTEDIR_CALLENUMEXT || '-' }}
                  Int. {{ direccion.CTEDIR_CALLENUMINT || '-' }}
                </li>
                <li><strong>Colonia:</strong> {{ direccion.CTEDIR_COLONIA }}</li>
                <li><strong>Entre calles:</strong> {{ direccion.CTEDIR_CALLEENTRE1 }} y {{ direccion.CTEDIR_CALLEENTRE2
                  }}</li>
                <li><strong>Código Postal:</strong> {{ direccion.CTEDIR_CP }}</li>
                <li>
                  <strong>Ciudad / Estado:</strong>
                  {{ direccion.CTEDIR_CIUDAD || '-' }}, {{ direccion.CTEDIR_ESTADO || '-' }}
                </li>
              </ul>

              <!-- Aviso Fiscal -->
              <p v-if="direccion.CTEDIR_TIPOFIS == 1" class="text-xs mt-2 italic opacity-80">
                (No editable, dirección fiscal)
              </p>
            </div>

          </div>

          <!-- Si NO hay direcciones -->
          <div v-else class="text-gray-300 text-center py-6">
            No tienes direcciones registradas.
          </div>
        </div>
      </div>

    </v-main>
    <bottom-navigation class="fixed-bottom-nav" />

  </v-app>
</template>

<script>
import axios from "axios";
import AppbarView from "../appbar/appbarView.vue";
import BottomNavigation from "../submenu/BottomNavigation.vue";
import { VCard, VBtn, VIcon } from "vuetify/components";

export default {
  name: "PerfilRewards",
  components: { AppbarView, BottomNavigation, VCard, VBtn, VIcon },
  data() {
    return {

      direcciones: [],
      dias: [],
      detallePedido: null,
      dialogDetalle: false,
      user: {},
      pedidos: [],
      loadingPedidos: false,
      selectedTab: "puntos",
      updatingPoints: false, // <-- nuevo

      tabs: [
        { name: "puntos", label: "Puntos", icon: "mdi-star-circle" },
        { name: "historial", label: "Historial", icon: "mdi-history" },
        { name: "politica", label: "Política de Privacidad", icon: "mdi-file-document" },
        { name: "direcciones", label: "Direcciones", icon: "mdi-map-marker" }, // <-- nueva pestaña

      ],
      cliente: null,
      privacyPolicy: null,
      checklist: [
        { text: "He leído el aviso de privacidad", checked: false },
        { text: "Acepto el uso de mis datos para procesar pedidos", checked: false },
        { text: "Autorizo recibir notificaciones y promociones", checked: false },
      ],
    };
  },
  computed: {
    direccionesFiltradas() {
      // 1️⃣ Tomamos SOLO UNA dirección fiscal
      const fiscal = this.direcciones.find(d => d.CTEDIR_TIPOFIS == 1);

      // 2️⃣ Tomamos direcciones de entrega
      const entregas = this.direcciones.filter(d => d.CTEDIR_TIPOFIS != 1);

      // 3️⃣ Construimos la lista final
      return fiscal ? [fiscal, ...entregas] : entregas;
    },
    pedidosOrdenados() {
      return this.pedidos
        .slice()
        .sort((a, b) => {
          // extraemos el número al final del ID
          const numA = parseInt(a.referencia_frog?.match(/(\d+)$/)?.[1] || 0, 10);
          const numB = parseInt(b.referencia_frog?.match(/(\d+)$/)?.[1] || 0, 10);

          // orden descendente: el más grande primero
          return numB - numA;
        });
    },
    allChecked() {
      return this.checklist.every(item => item.checked);
    },
    canAccept() {
      if (!this.allChecked || !this.privacyPolicy || !this.cliente) return false;
      return this.cliente.privacyPolicyVersion !== this.privacyPolicy.version;
    },
    checklistDisabled() {
      return this.cliente?.privacyPolicyVersion === this.privacyPolicy?.version;
    },
  },
  methods: {
    selectTab(tab) {
      this.selectedTab = tab;
      if (tab === "historial") this.obtenerConsultaPedidos();
    },
    copyId() {
      if (this.user?.id) navigator.clipboard.writeText(this.user.id);
    },
    async obtenerNuevaData() {
      try {
        this.updatingPoints = true; // inicio loader
        const savedUser = JSON.parse(localStorage.getItem("user"));
        if (!savedUser?.id) return;

        const res = await axios.get(`https://mvexpress.mx/api/get-mvcoins/${savedUser.id}`);

        // actu
        // alizar el usuario en la vista y en localStorage
        this.user = { ...savedUser, ...res.data };
        this.cliente = this.user;
        localStorage.setItem("user", JSON.stringify(this.user));

        console.log("Puntos actualizados:", this.user.mvCoins);
      } catch (err) {
        console.error("Error al actualizar puntos:", err);
        alert("Ocurrió un error al actualizar puntos.");
      } finally {
        this.updatingPoints = false; // fin loader
      }
    },

    async obtenerDirecciones() {
      console.log("🔹 obtenerDirecciones() iniciado");
      this.isLoading = true;
      try {
        const user = JSON.parse(localStorage.getItem("user"));
        console.log("Usuario desde localStorage:", user);

        if (!user || !user.cliente) {
          console.error("Usuario no encontrado en localStorage");
          return;
        }

        const cacheKey = `direcciones_${user.cliente}`;
        const cacheTimeKey = `${cacheKey}_timestamp`;
        const now = Date.now();
        const oneWeek = 0 * 60 * 1000; // 1 semana en ms (puedes ajustar)

        const cachedData = localStorage.getItem(cacheKey);
        const cachedTime = localStorage.getItem(cacheTimeKey);

        console.log("cachedData:", cachedData, "cachedTime:", cachedTime);

        if (cachedData && cachedTime && now - cachedTime < oneWeek) {
          this.direcciones = JSON.parse(cachedData);
          console.log("Direcciones desde cache:", this.direcciones);
          return;
        }

        console.log("Consultando API de direcciones...");
        const response = await axios.get(
          `https://mvexpress.mx/api/find-direccion/${user.cliente}`
        );
        console.log("Respuesta de la API:", response.data);
        this.direcciones = response.data;

        // Guardar en localStorage si no es muy pesado
        try {
          const jsonData = JSON.stringify(response.data);
          if (jsonData.length < 4 * 1024 * 1024) {
            localStorage.setItem(cacheKey, jsonData);
            localStorage.setItem(cacheTimeKey, now);
            console.log("Direcciones guardadas en localStorage");
          } else {
            console.warn("Respuesta muy grande, no se guardará en localStorage.");
          }
        } catch (e) {
          console.warn("No se pudo guardar en localStorage:", e.message);
        }
      } catch (error) {
        console.error("Error al obtener las direcciones:", error);
        this.errorMessage = error.response
          ? `Error ${error.response.status}: ${error.response.data.message}`
          : "No se pudo conectar con el servidor.";
      } finally {
        this.isLoading = false;
        console.log("🔹 obtenerDirecciones() finalizado, isLoading:", this.isLoading);
      }
    },

    async obtenerConsultaPedidos() {
      try {
        const user = JSON.parse(localStorage.getItem("user"));
        if (!user?.cliente) return;
        this.loadingPedidos = true;
        const url = `https://mvexpress.mx/api/cliente/pedido/${user.cliente}`;
        const res = await axios.get(url);
        this.pedidos = Array.isArray(res.data) ? res.data : [res.data];
      } catch (err) {
        console.error("Error al obtener pedidos:", err);
      } finally {
        this.loadingPedidos = false;
      }
    },
    async showProducto(pedido) {
      try {
        const idPedido = pedido.pedido_id || pedido.id || pedido.referencia_frog;
        if (!idPedido) return;

        const { data } = await axios.get(`https://mvexpress.mx/api/find/pedido/${idPedido}`);
        const detalles = Array.isArray(data) ? data : data.detalles || [];
        this.detallePedido = { ...pedido, detalles };
        this.dialogDetalle = true;
      } catch (err) {
        console.error(err);
      }
    },

    async cargarPolitica() {
      try {
        const res = await axios.get("https://mvexpress.mx/api/privacy-policy");
        this.privacyPolicy = res.data;
      } catch (err) {
        console.error(err);
      }
    },
    async guardarChecklist() {
      if (!this.allChecked) return;
      localStorage.setItem("avisoPrivacidadConfirmado", JSON.stringify(this.checklist));

      try {
        const token = localStorage.getItem("token");
        if (!token || !this.cliente?.id) throw new Error("Faltan datos");

        const res = await axios.post(
          "https://mvexpress.mx/api/aceptar-terminos",
          { userId: this.cliente.id },
          { headers: { Authorization: `Bearer ${token}` } }
        );

        this.cliente.politica_privacidad_aceptada = true;
        this.cliente.fecha_politica_privacidad = new Date().toISOString();
        this.cliente.privacyPolicyVersion = this.privacyPolicy.version;
        localStorage.setItem("user", JSON.stringify(this.cliente));

        alert(res.data.message);
      } catch (err) {
        console.error(err);
        alert("Ocurrió un error al guardar la aceptación.");
      }
    },
  },
  async mounted() {
    const user = JSON.parse(localStorage.getItem("user"));
    if (user) {
      this.user = user;

      // Tomamos direcciones y nos aseguramos que siempre tengan dia
      this.direcciones = (user.direcciones || []).map(d => ({
        ...d,
        dia: d.dia || 'Sin frecuencia'  // Si ya existe dia, lo mantiene
      }));

      console.log("Direcciones cargadas del login:", this.direcciones);
    }

    await this.obtenerNuevaData();
    await this.cargarPolitica();

    // Solo actualiza info extra sin tocar dia
    await this.obtenerDirecciones(true);

    const storedChecklist = localStorage.getItem("avisoPrivacidadConfirmado");
    if (storedChecklist) this.checklist = JSON.parse(storedChecklist);
  },


};
</script>


<style>
.snackbar-top {
  top: 30px !important;
  /* Ajusta la distancia del top */
  bottom: auto !important;
  z-index: 2000 !important;
}

.main-content {
  height: 100vh;
  /* Ocupa toda la pantalla */
  padding-bottom: 30px;
  /* Deja espacio para la bottom-navigation */
}

.marcas {
  display: flex;
  /* asegura que flex funcione */
  justify-content: center;
  /* centra elementos */
  overflow-x: auto;
  /* scroll horizontal */
  padding: 0 16px;
  /* margen interno */
  gap: 20px;
  /* espacio entre items */
  scroll-behavior: smooth;
  /* scroll suave */
}

.marcas::-webkit-scrollbar {
  display: none;
}

/* Cada item no se reduce */
.marcas .v-col {
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  /* centra contenido dentro de la columna */
  padding: 0;
}

.fixed-cart-btn {
  position: fixed;
  left: 50%;
  transform: translateX(-50%);
  z-index: 9999;

  /* SUBE el botón justo arriba de la bottom nav */
  bottom: calc(env(safe-area-inset-bottom) + 70px);

  display: flex;
  align-items: center;
  justify-content: center;
  padding: 10px 20px;

  border-radius: 50px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.3);
  font-size: 16px;
  background-color: #fff;
}

.fixed-bottom-nav {
  position: fixed;
  left: 0;
  right: 0;
  bottom: env(safe-area-inset-bottom);
  /* respeta la zona segura del teléfono */
  z-index: 9999;
}

/* Para Samsung donde env(safe-area) no se reporta correctamente */
@supports (bottom: env(safe-area-inset-bottom)) {
  .fixed-cart-btn {
    bottom: calc(max(env(safe-area-inset-bottom), 20px) + 70px);
  }
}
</style>